import {DateService} from "nuxt-spoferan/src/services/DateService";

export default (context, inject) => {
    inject('date', (date, format = null) => {
        return new DateService(date, format, context.i18n?.locale ?? 'de');
    });
}